/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

export default function FreeZoneSingleAccordion({ data, id }) {
  const {
    singleAccordionSubtitle,
    singleAccordionTitle,
    singleAccordionDescription,
    singleAccordionText,
    image,
    mobileImage,
  } = data;

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const containerVariants = {
    open: {
      height: 'auto',
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      },
    },
    closed: {
      height: 0,
      transition: {
        duration: 0.3,
        ease: 'easeIn',
      },
    },
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.4 }}
      viewport={{ once: true }}
      id={id}
      className="pt-[25px] md:pt-[63px]">
      <BoxedContainer className="relative">
        {!isEmpty(image) && (
          <motion.div
            className="accordion-image overflow-hidden"
            variants={containerVariants}
            initial="open"
            animate={isAccordionOpen ? 'closed' : 'open'}>
            <LazyLoadImage
              src={image.url}
              alt={singleAccordionTitle}
              className="!relative w-full h-auto min-h-[168px] object-cover hidden md:block"
            />
            {isEmpty(mobileImage) || (
              <LazyLoadImage
                src={mobileImage.url}
                alt={singleAccordionTitle}
                className="!relative w-full h-auto min-h-[168px] object-cover block md:hidden"
              />
            )}
          </motion.div>
        )}

        <div className="bg-white border border-[#E6E6E6] p-5 md:p-[30px]">
          <div className="flex flex-col gap-y-[15px] md:gap-y-[30px] justify-center">
            <button
              type="button"
              onClick={toggleAccordion}
              className="flex flex-row gap-5 justify-between items-center">
              <div className="flex flex-col gap-y-[10px] md:gap-y-[15px]">
                <h5
                  className="text-clamp12to14 ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight uppercase text-[#58595B]
                ltr:text-left rtl:text-right">
                  {singleAccordionSubtitle}
                </h5>
                <h3
                  className="text-clamp14to20 ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium  text-[#58595B]
              leading-1.5 ltr:text-left rtl:text-right !m-0">
                  {singleAccordionTitle}
                </h3>
              </div>
              <Sprites
                name="arrow-up"
                className={`${isAccordionOpen ? 'rotate-[180deg]' : 'rotate-[0deg]'}`}
              />
            </button>
            <div
              dangerouslySetInnerHTML={{ __html: singleAccordionDescription }}
              className="p-child:text-clamp12to18 p-child:text-[#4A4A4A]
              ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3].5 max-w-[940px] p-child:!m-0"
            />
            <motion.div
              className="overflow-hidden"
              variants={containerVariants}
              initial="closed"
              animate={isAccordionOpen ? 'open' : 'closed'}>
              <div
                dangerouslySetInnerHTML={{ __html: singleAccordionText }}
                className={`p-child:text-clamp12to16 p-child:text-[#4A4A4A]
              ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight ltr:leading-1 rtl:leading-[1.3].5
              max-w-[1075px] p-child:!m-0`}
              />
            </motion.div>
          </div>
        </div>
      </BoxedContainer>
    </motion.section>
  );
}
